/* eslint-disable you-dont-need-momentjs/no-import-moment */
/* eslint-disable you-dont-need-momentjs/no-moment-constructor */
import moment from 'moment'

import { createAsyncTypes } from 'utils/ActionCreator'
import { addWorkingDays, getCountOfWorkingDays } from 'utils/dateUtils'

import { CAMPAIGN_TYPES_VALUES, DELIVERY } from 'containers/AwarenessCenter/constants'

import { DEFAULT_SIMULATION_CAMPAIGN_OBJECT } from '../WizardSimulationCampaign/constants'
import {
  getSimulationCampaignLaunchProperties,
  mapSimulationValidatorByName,
} from '../WizardSimulationCampaign/utils'
import { DEFAULT_SPEAR_PHISHING_CAMPAIGN_OBJECT } from '../WizardSpearPhishingCampaign/constants'
import { DEFAULT_TRAINING_CAMPAIGN_OBJECT } from '../WizardTrainingCampaign/constants'
import {
  getTrainingCampaignLaunchProperties,
  mapTrainingValidatorByName,
} from '../WizardTrainingCampaign/utils'

import 'moment-timezone'

const typeKey = 'AwarenessCenter/WizardCampaign'

export const GET_CAMPAIGN_ASYNC = createAsyncTypes('GET_CAMPAIGN', typeKey)
export const SAVE_DRAFT_ASYNC = createAsyncTypes('SAVE_DRAFT', typeKey)
export const REMOVE_DRAFT_ASYNC = createAsyncTypes('REMOVE_DRAFT', typeKey)
export const SAVE_AND_APPROVE_CAMPAIGN_ASYNC = createAsyncTypes(
  'SAVE_AND_APPROVE_CAMPAIGN',
  typeKey
)
export const SAVE_AND_TEST_CAMPAIGN_ASYNC = createAsyncTypes('SAVE_AND_TEST_CAMPAIGN', typeKey)
export const APPROVE_CAMPAIGN_ASYNC = createAsyncTypes('APPROVE_CAMPAIGN', typeKey)

export const CHANGE_NAME = `${typeKey}/CHANGE_NAME`
export const CHANGE_DEFAULT_LOCALE_ID = `${typeKey}/CHANGE_DEFAULT_LOCALE_ID`
export const TOGGLE_TOURNAMENT = `${typeKey}/TOGGLE_TOURNAMENT`
export const CHANGE_TIMEZONE = `${typeKey}/CHANGE_TIMEZONE`
export const CHANGE_LAUNCH_DATE = `${typeKey}/CHANGE_LAUNCH_DATE`
export const CHANGE_LAUNCH_TIME = `${typeKey}/CHANGE_LAUNCH_TIME`
export const CHANGE_END_DATE = `${typeKey}/CHANGE_END_DATE`
export const CHANGE_CLOSE_TIME = `${typeKey}/CHANGE_CLOSE_TIME`
export const CHANGE_SEND_REMINDERS_UNTIL = `${typeKey}/CHANGE_SEND_REMINDERS_UNTIL`
export const CHANGE_MAX_EMAIL_PER_DAY = `${typeKey}/CHANGE_MAX_EMAIL_PER_DAY`
export const CHANGE_DELIVERY = `${typeKey}/CHANGE_DELIVERY`
export const TOGGLE_RANDOMIZED = `${typeKey}/TOGGLE_RANDOMIZED`
export const TOGGLE_SEND_ALL_WEEK = `${typeKey}/TOGGLE_SEND_ALL_WEEK`
export const TOGGLE_SCENARIO = `${typeKey}/TOGGLE_SCENARIO`
export const TOGGLE_SENDING_TYPE = `${typeKey}/TOGGLE_SENDING_TYPE`
export const TOGGLE_LANDING_PAGE = `${typeKey}/TOGGLE_LANDING_PAGE`
export const TOGGLE_TRAINING_VIDEO = `${typeKey}/TOGGLE_TRAINING_VIDEO`
export const SET_TRAINING_VIDEOS = `${typeKey}/SET_TRAINING_VIDEOS`
export const SET_PLAYLIST_MODE_ASYNC = createAsyncTypes('SET_PLAYLIST_MODE', typeKey)
export const REORDER_PLAYLIST_VIDEO_ASYNC = createAsyncTypes('REORDER_PLAYLIST_VIDEO', typeKey)
export const PUT_WORKDAYS = `${typeKey}/PUT_WORKDAYS`
export const RESET_WIZARD = `${typeKey}/RESET_WIZARD`
export const INIT_EDIT_MODE = `${typeKey}/INIT_EDIT_MODE`
export const RESET_CAMPAIGN_INPROGRESS_FLAG = `${typeKey}/RESET_CAMPAIGN_INPROGRESS_FLAG`
export const RESET_CAMPAIGN_TYPE_FLAGS = `${typeKey}/RESET_CAMPAIGN_TYPE_FLAGS`
export const TOGGLE_SEND_REMINDER_EVERY_X_BUSINESS_DAYS = `${typeKey}/TOGGLE_SEND_REMINDER_EVERY_X_BUSINESS_DAYS`
export const CHANGE_PARTICIPANTS_SELECTION = `${typeKey}/CHANGE_PARTICIPANTS_SELECTION`
export const CHANGE_PARTICIPANTS_TOTAL_SELECTION = `${typeKey}/CHANGE_PARTICIPANTS_TOTAL_SELECTION`
export const TOGGLE_NOTIFY_THOSE_WHO_FAILED = `${typeKey}/TOGGLE_NOTIFY_THOSE_WHO_FAILED`
export const TOGGLE_SEND_CAMPAIGN_SUMMARY_TO_CAMPAIGN_REPORT_RECIPIENTS = `${typeKey}/TOGGLE_SEND_CAMPAIGN_SUMMARY_TO_CAMPAIGN_REPORT_RECIPIENTS`
export const CHANGE_SEND_COMPLETION_EMAIL = `${typeKey}/CHANGE_SEND_COMPLETION_EMAIL`
export const SET_SHARED_MAILBOX_PARTICIPANTS = `${typeKey}/SET_SHARED_MAILBOX_PARTICIPANTS`
export const CHANGE_TRAINING_REMINDERS = `${typeKey}/CHANGE_TRAINING_REMINDERS`
export const SET_CONTROLS_MESSAGE = `${typeKey}/SET_CONTROLS_MESSAGE`
export const ADD_CAMPAIGN_NOTIFICATION = `${typeKey}/ADD_CAMPAIGN_NOTIFICATION`
export const CHANGE_MANAGER_REPORT_REMINDERS_THRESHOLD = `${typeKey}/CHANGE_MANAGER_REPORT_REMINDERS_THRESHOLD`
export const CHANGE_SEND_MANAGER_REPORT_EVERY_X_DAYS = `${typeKey}/CHANGE_SEND_MANAGER_REPORT_EVERY_X_DAYS`
export const CHANGE_MANAGER_REPORT_DAY_OF_WEEK = `${typeKey}/CHANGE_MANAGER_REPORT_DAY_OF_WEEK`
export const CHANGE_MANAGER_NOTIFICATION_DATA = `${typeKey}/CHANGE_MANAGER_NOTIFICATION_DATA`
export const CHANGE_TRIGGER_BASED_CAMPAIGN_DATA = `${typeKey}/CHANGE_TRIGGER_BASED_CAMPAIGN_DATA`
export const CHANGE_MAX_REMINDERS_PER_PARTICIPANT = `${typeKey}/CHANGE_MAX_REMINDERS_PER_PARTICIPANT`
export const CHANGE_IS_END_DATE_WAS_MANUALLY_CHANGED = `${typeKey}/CHANGE_IS_END_DATE_WAS_MANUALLY_CHANGED`
export const TOGGLE_COMPLETION_NOTIFICATION_SETTING = `${typeKey}/TOGGLE_COMPLETION_NOTIFICATION_SETTING`

export const MINIMUM_COLLECTION_PERIOD = 3

export const SENDING_VALUES = {
  RANDOMIZED: 1,
  LEVELED: 2,
}

export const MAP_DELIVERY_TYPE = {
  [DELIVERY.EMAIL]: 'Email',
  [DELIVERY.SMS]: 'SMS',
}

export const MAP_DELIVERY_VALUE = {
  Email: DELIVERY.EMAIL,
  SMS: DELIVERY.SMS,
}

export const MAP_DELIVERY_TYPE_PLURAL = {
  [DELIVERY.EMAIL]: 'Emails',
  [DELIVERY.SMS]: 'SMS',
}

export const CREATED_BY_VALUES = {
  SYSTEM: 1,
  COMPANY: 2,
  MSP: 3,
  ALL_TYPES: 4,
}

export const CREATED_BY_LABELS = {
  [CREATED_BY_VALUES.SYSTEM]: 'System',
  [CREATED_BY_VALUES.COMPANY]: 'Company',
  [CREATED_BY_VALUES.MSP]: 'MSP',
  [CREATED_BY_VALUES.ALL_TYPES]: 'All',
}

export const CREATED_BY_OPTIONS = [
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.ALL_TYPES],
    value: CREATED_BY_VALUES.ALL_TYPES,
  },
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.COMPANY],
    value: CREATED_BY_VALUES.COMPANY,
  },
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.SYSTEM],
    value: CREATED_BY_VALUES.SYSTEM,
  },
]

export const CREATED_BY_MSP_OPTIONS = [
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.ALL_TYPES],
    value: CREATED_BY_VALUES.ALL_TYPES,
  },
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.MSP],
    value: CREATED_BY_VALUES.MSP,
  },
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.COMPANY],
    value: CREATED_BY_VALUES.COMPANY,
  },
  {
    label: CREATED_BY_LABELS[CREATED_BY_VALUES.SYSTEM],
    value: CREATED_BY_VALUES.SYSTEM,
  },
]

export const NAME_FOR_HISTORY_STORE = 'campaignWizard'

export const DEFAULT_CAMPAIGN_OBJECTS_MAP = {
  [CAMPAIGN_TYPES_VALUES.SIMULATION]: DEFAULT_SIMULATION_CAMPAIGN_OBJECT,
  [CAMPAIGN_TYPES_VALUES.TRAINING]: DEFAULT_TRAINING_CAMPAIGN_OBJECT,
  [CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING]: DEFAULT_SPEAR_PHISHING_CAMPAIGN_OBJECT,
}

export const GET_CAMPAIGN_LAUNCH_PROPERTIES_MAP = {
  [CAMPAIGN_TYPES_VALUES.SIMULATION]: getSimulationCampaignLaunchProperties,
  [CAMPAIGN_TYPES_VALUES.TRAINING]: getTrainingCampaignLaunchProperties,
  [CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING]: getSimulationCampaignLaunchProperties,
}

export const VALIDATORS_MAP = {
  [CAMPAIGN_TYPES_VALUES.SIMULATION]: mapSimulationValidatorByName,
  [CAMPAIGN_TYPES_VALUES.TRAINING]: mapTrainingValidatorByName,
  [CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING]: mapSimulationValidatorByName,
}

export const DEFAULT_LAUNCH_DATE_GAP = 10

export const getSendingDays = (LaunchDate, endDate, weekendDays) =>
  getCountOfWorkingDays(moment(LaunchDate).clone(), moment(endDate), weekendDays)

const resolveScheduleMoment = ({ launchDate, launchTime, timezone }) => {
  if (!launchDate) {
    return null
  }

  const launchDateString = String(launchDate)
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(launchDateString)

  if (isDateOnly && launchTime && timezone) {
    return moment.tz(`${launchDateString} ${launchTime}`, 'YYYY-MM-DD HH:mm', timezone)
  }

  return moment(launchDate)
}

export const getSendingRemindersCount = ({
  launchDate,
  launchTime,
  timezone,
  sendRemindersUntil,
  weekend,
  sendReminderEveryXBusinessDays,
}) => {
  if (!launchDate || !sendRemindersUntil || weekend == null || !sendReminderEveryXBusinessDays) {
    return null
  }

  const start = resolveScheduleMoment({ launchDate, launchTime, timezone })
  const end = moment(sendRemindersUntil)

  if (!start?.isValid() || !end.isValid()) {
    return 0
  }

  let remindersCount = 0
  let nextReminderTime = addWorkingDays(start.clone(), sendReminderEveryXBusinessDays, weekend)

  while (nextReminderTime.isSameOrBefore(end)) {
    remindersCount += 1
    nextReminderTime = addWorkingDays(nextReminderTime, sendReminderEveryXBusinessDays, weekend)
  }

  return remindersCount
}

export const ERROR_CODES = {
  INVALID_SCENARIO: 'INVALID_SCENARIO',
}

export const MANAGER_NOTIFICATION_MINIMUM_PARTICIPANTS_ONWARDS = 1
export const MANAGER_NOTIFICATION_START_NOTIFY_WEEK_VALUES = {
  EVERY_WEEK: 7,
  EVERY_OTHER_WEEK: 14,
}
export const MANAGER_NOTIFICATION_START_NOTIFY_WEEK_OPTIONS = [
  { label: 'every week', value: MANAGER_NOTIFICATION_START_NOTIFY_WEEK_VALUES.EVERY_WEEK },
  {
    label: 'every other week',
    value: MANAGER_NOTIFICATION_START_NOTIFY_WEEK_VALUES.EVERY_OTHER_WEEK,
  },
]
export const MANAGER_NOTIFICATION_START_NOTIFY_DAY_OPTIONS = [
  {
    label: 'Monday',
    value: 0,
  },
  {
    label: 'Tuesday',
    value: 1,
  },
  {
    label: 'Wednesday',
    value: 2,
  },
  {
    label: 'Thursday',
    value: 3,
  },
  {
    label: 'Friday',
    value: 4,
  },
  {
    label: 'Saturday',
    value: 5,
  },
  {
    label: 'Sunday',
    value: 6,
  },
]

export const MANAGER_NOTIFICATION_STATE_VALUES = {
  HIDDEN: 'hidden',
  DISABLED: 'disabled',
  ENABLED: 'enabled',
}

export const INDIVIDUAL_DELAY_UNIT_VALUES = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
}

export const INDIVIDUAL_DELAY_UNIT_LABELS = {
  [INDIVIDUAL_DELAY_UNIT_VALUES.DAY]: 'Day',
  [INDIVIDUAL_DELAY_UNIT_VALUES.WEEK]: 'Week',
  [INDIVIDUAL_DELAY_UNIT_VALUES.MONTH]: 'Month',
}

export const INDIVIDUAL_DELAY_UNIT_OPTIONS = [
  {
    label: INDIVIDUAL_DELAY_UNIT_LABELS[INDIVIDUAL_DELAY_UNIT_VALUES.DAY],
    value: INDIVIDUAL_DELAY_UNIT_VALUES.DAY,
  },
  {
    label: INDIVIDUAL_DELAY_UNIT_LABELS[INDIVIDUAL_DELAY_UNIT_VALUES.WEEK],
    value: INDIVIDUAL_DELAY_UNIT_VALUES.WEEK,
  },
  {
    label: INDIVIDUAL_DELAY_UNIT_LABELS[INDIVIDUAL_DELAY_UNIT_VALUES.MONTH],
    value: INDIVIDUAL_DELAY_UNIT_VALUES.MONTH,
  },
]

export const DEFAULT_TRIGGER_BASED_CAMPAIGN_DATA = {
  individualDelayValue: 1,
  individualDelayUnit: INDIVIDUAL_DELAY_UNIT_VALUES.WEEK,
  collectingPeriodValue: 7,
  collectingPeriodUnit: INDIVIDUAL_DELAY_UNIT_VALUES.DAY,
}

export const YEAR_WORK_DAYS = 261
export const FULL_YEAR_DAYS = 365
